import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import contentRequest from '@ertelecom/ui-react/components/requests/contentRequest';
import Layout from '~/src/layout/_layout';
import { requestDataAction, setTariffsForQuizAction } from '~/src/store/actions/quiz';
import * as base from '~/src/helpers/basePageFunc';
import EquipmentDomruTv from '~/src/layout/equipment/domruTv';
import { getBanners } from '~/src/api/banners';
import { EExpandShopItems, EShopCategory, getShopItems } from '~/src/api/content/shop/getShopItems';
import { selectDomain } from '~/src/store/selectors/domain';

const aliasForQuiz = 'tvbox';
const promiseWrap = (promise, defaultValue) => promise.then(res => res, () => defaultValue);

class DomruTvEquipmentPage extends Component {
    static propTypes = {
        city: PropTypes.object,
        hostname: PropTypes.string,
        productList: PropTypes.array,
        alias: PropTypes.string,
        banners: PropTypes.array,
    };

    static async getInitialProps(options) {
        const { store, query: { itemId: alias } } = options;
        const { hostname } = await base.initialProps(options);
        const state = await store.getState();
        const billingDomain = selectDomain(state);
        const { city, internet, auth: { accessToken } } = state;
        const { domain } = city.currentCity;

        const [productList, bannerResp] =
            await Promise.all([
                promiseWrap(getShopItems(
                    billingDomain,
                    accessToken,
                    EShopCategory.Decoders,
                    [EExpandShopItems.Category, EExpandShopItems.Labels, EExpandShopItems.Props],
                ), []),
                promiseWrap(getBanners(domain, false, 'domrutv_equipment'), {}),
            ]);

        try {
            store.dispatch(requestDataAction([], {}));
            const quizData = await contentRequest(`${domain}/v1/quiz/view?id=${aliasForQuiz}`);
            const quiz = quizData.data;
            const quizInfo = {
                alias: quiz.alias,
                available: quiz.available,
                available_auth: quiz.available_auth,
                available_new: quiz.available_new,
                title: quiz.title,
            };
            await Promise.all([
                store.dispatch(requestDataAction(quiz.questions, quizInfo)),
                store.dispatch(setTariffsForQuizAction(internet.tariffs)),
            ]);
        } catch (e) {
            console.info('quizData Not Found');
        }

        // TODO: удалить костыль после WEB-25063
        const MOVIX_PRO_VOICE = 101183;
        const EXCLUDE_DURATION = 36;
        const products = productList.map(product => {
            if (product.global_id === MOVIX_PRO_VOICE) {
                const { leasing = [] } = product.prices;
                return {
                    ...product,
                    prices: {
                        ...product.prices,
                        leasing: leasing.filter(price => price.duration !== EXCLUDE_DURATION)
                    }
                };
            }
            return product;
        });

        return {
            hostname,
            productList: products,
            banners: bannerResp.data ? bannerResp.data.items : [],
            alias,
        };
    }

    render() {
        const { city, hostname, productList, banners, alias = 'main' } = this.props;

        return (
            <Layout
                title={` ТВ приставки для цифрового телевидения в ${city.cityIn} | Купить оборудование для телевизора, цена от Дом.ru`}
                description={`Официальный сайт провайдера Дом.ru в ${city.cityIn} | Беспроцентная рассрочка на цифровые ТВ приставки Movix и Movix Pro. Узнайте подробнее на сайте или по ${city.callCenter}`}
                hostname={hostname}
                withMenu={true}
                withChat={true}
                withFooter={true}
                relCanonical={`https://${hostname}/domru-tv/equipment`}
            >
                <EquipmentDomruTv
                    city={city}
                    productList={productList}
                    pageAlias={alias}
                    banners={banners}
                />
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
});

export default connect(mapStateToProps)(DomruTvEquipmentPage);
